import React, { useCallback } from 'react'
import { Link } from 'gatsby'
import { Columns, Column } from 'react-flex-columns'
import workshops from '../../data/workshops'
import WorkshopTicketStatus from './WorkshopTicketStatus'
import api from '../../utils/api'
import usePromise from 'shared/hooks/usePromise'
import { getDateRangeText, eventIsPast } from 'shared/utils/dates'
import Notice from 'shared/ui/Notice'
import './WorkshopListings.scss'

export default function PublicWorkshopListings() {
  if (!Array.isArray(workshops) || workshops.length === 0) {
    return <Notice>We will be announcing new Public Workshops in early July!</Notice>
  }

  const hiddenWorkshops = workshops.find((w) => w.showWorkshop === false)

  return (
    <div className="spacing-small">
      {process.env.GATSBY_ACTIVE_ENV === 'development' && hiddenWorkshops && (
        <Notice>
          Some workshops have `showWorkshop = false`. Check the <code>/data/workshops.js</code>{' '}
          file. This setting hides or shows workshops in production only.
        </Notice>
      )}
      {workshops.map((ws) => {
        return !ws.private ? <ListingItem key={ws.id} {...ws} /> : null
      })}
    </div>
  )
}

function ListingItem({ id, title, subTitle, startDate, days, minutes }) {
  const getWorkshopPricing = useCallback(() => api.getWorkshop(id), [id])
  const { response, loading, error } = usePromise(getWorkshopPricing)
  const workshopServerData = !loading && !error && response

  const workshopEnded = eventIsPast(startDate, days)
  const ticketSalesEnded = eventIsPast(startDate)
  const WorkshopEnded = workshopEnded ? 'strike' : 'span'

  return (
    <div className="public-workshop-listing-item">
      <Columns split>
        <Column>
          <div>
            <Link to={`/public-workshops/${id}`} className="location text-no-wrap block">
              <strong>{title}</strong>
            </Link>
            <span className="block text-xsmall horizontal-spacing-small">
              <strong>{minutes > 0 ? `${minutes} Minutes` : `${days} Day`}:</strong>
              <span>{subTitle}</span>
            </span>
          </div>
        </Column>
        <Column className="align-right">
          <span className="block dates">
            <WorkshopEnded>{getDateRangeText(startDate, days)}</WorkshopEnded>
          </span>
          {workshopEnded && <span className="block text-warn text-small">This event is over</span>}
        </Column>
      </Columns>
      {!workshopEnded && (
        <WorkshopTicketStatus ticketSalesEnded={ticketSalesEnded} {...workshopServerData} />
      )}
    </div>
  )
}
